import { z } from 'zod';
import { recordingPinSchema } from '../api/macroPackage/authoringPrimitives';

export const MACRO_RECORDING_CATALOG_ACTION = 'macroPackageRecordingCatalog';
export const HOST_RECORDING_CATALOG_PAGE_SIZE = 8;
export const hostRecordingCatalogQuerySchema = z.object({ campaignId: z.string().min(1).max(128), cursor: z.string().uuid().optional() }).strict();
export const hostRecordingCatalogPageSchema = z.object({
  records: z.array(z.object({ pin: recordingPinSchema, name: z.string().min(1).max(80), createdAtUnixMs: z.number().int().nonnegative().safe() }).strict())
    .max(HOST_RECORDING_CATALOG_PAGE_SIZE),
  nextCursor: z.string().uuid().nullable(), verificationFailures: z.number().int().nonnegative().max(32),
}).strict();
const identity = { requestId: z.string().uuid(), hostId: z.string().min(1).max(128), campaignId: z.string().min(1).max(128), sessionId: z.string().uuid() };
export const macroRecordingCatalogRequestSchema = z.object({ ...identity, cursor: z.string().uuid().optional() }).strict();
export const macroRecordingCatalogReplySchema = z.discriminatedUnion('success', [
  z.object({ ...identity, success: z.literal(true), page: hostRecordingCatalogPageSchema }).strict(),
  z.object({ ...identity, success: z.literal(false), error: z.string().regex(/^[a-z0-9_]{1,128}$/) }).strict(),
]);
export type HostRecordingCatalogPage = z.infer<typeof hostRecordingCatalogPageSchema>;
export type MacroRecordingCatalogRequest = z.infer<typeof macroRecordingCatalogRequestSchema>;
export type MacroRecordingCatalogReply = z.infer<typeof macroRecordingCatalogReplySchema>;
export type PlaycastMacroRecordingCatalogMessages =
  | { target: 'system'; action: 'macroPackageRecordingCatalog'; isReply: false; message: MacroRecordingCatalogRequest }
  | { target: 'system'; action: 'macroPackageRecordingCatalog'; isReply: true; message: MacroRecordingCatalogReply };
